/* eslint-disable spire/export-styles */
import ADIColors from "@NA/Utils/ADIColors";
import { getIsWebCrawler } from "@insite/client-framework/Common/WebCrawler";
import { HasCategoryContext, withCategory } from "@insite/client-framework/Components/CategoryContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSelectedCategoryPath } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCatalogPageStateByPath } from "@insite/client-framework/Store/Data/CatalogPages/CatalogPagesSelectors";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { CategoryDetailsPageContext } from "@insite/content-library/Pages/CategoryDetailsPage";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import { ProductListPageContext } from "@insite/content-library/Pages/ProductListPage";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    const location = getLocation(state);
    const categoryPath =
        getSelectedCategoryPath(state) ||
        (location.pathname.toLowerCase().startsWith("/content/") ? "" : location.pathname);
    const catalogPageState = getCatalogPageStateByPath(state, categoryPath).value;
    return {
        currentPage: getCurrentPage(state),
        breadcrumbLinks: state.components.breadcrumbs.links,
        catalogPageState,
    };
};

export interface CategoryNameStyles {
    category?: TypographyProps;
}

export const categoryNameStyles: CategoryNameStyles = {
    category: {
        css: css`
            text-align: center;
        `,
    },
};

type Props = WidgetProps & HasCategoryContext & ReturnType<typeof mapStateToProps>;
const styles = categoryNameStyles;
const CategoryName = ({ category, currentPage, breadcrumbLinks, catalogPageState }: Props) => {
    if (catalogPageState) {
        const isSearchCrawlerBrands = getIsWebCrawler();
        if (catalogPageState?.uri.includes("shop-brands/")) {
            styles.category = {
                css: css`
                    text-align: left;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                css`
                                    margin-bottom: 5px;
                                    font-size: 26px;
                                `,
                                null,
                                null,
                            ],
                            "max",
                        )}
                `,
            };
            return (
                <Typography
                    {...styles.category}
                    variant={isSearchCrawlerBrands && currentPage.type === "CategoryDetailsPage" ? "h1" : "h2"}
                >
                    {catalogPageState?.title}
                </Typography>
            );
        }
    }

    if (!category) {
        return null;
    }

    const isSearchCrawler = getIsWebCrawler();  
     if (
        category.name === "bycat" ||
        category.path === "/Catalog/shopproducts" ||
        currentPage.type === "ProductListPage"
    ) {
        styles.category = {
            css: css`
                font-size: 36px;
                margin-bottom: 35px;
                font-weight: bold;
                justify-self: left;
                text-align: left;
                color: ${ADIColors.darkBlue1};
                margin-top: -5px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                margin-bottom: 5px;
                                font-size: 26px;
                            `,
                            css`
                                margin-bottom: 5px;
                                font-size: 26px;
                            `,
                            css`
                                margin-bottom: 5px;
                                font-size: 26px;
                            `,
                            null,
                            null,
                        ],
                        "max",
                    )}
            `,
        };
    } else if (category.path.toLowerCase() === "/catalog/deals") {
        styles.category = {
            css: css`
                color: ${ADIColors.darkBlue1};
                font-weight: 900;
                font-size: 52px;
                line-height: 48px;
                margin: 0 0 20px 0;
            `,
        };
    } else if (category.name === "New Product") {
        styles.category = {
            css: css`
                text-align: left;
            `,
        };
    } else {
        styles.category = {
            css: css`
                text-align: center;
            `,
        };
    }

    return (
        <Typography
            {...styles.category}
            // Do not remove later will use if required.
            // variant={isSearchCrawler && currentPage.type === "CategoryDetailsPage" ? "h1" : "h2"}
            variant={"h1"}
        >
            {category.path?.toLowerCase() === "/catalog/deals" ? "Deals Center" : category.shortDescription}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withCategory(CategoryName)),
    definition: {
        group: "Categories",
        icon: "PageTitle",
        allowedContexts: [CategoryDetailsPageContext, ProductDetailsPageContext, ProductListPageContext],
    },
};

export default widgetModule;
